import {
  createServiceAreaPage,
  createServiceAreaStaticPaths,
  createServiceAreaStaticProps,
} from '@lib/createServiceAreaPage';

const HeatingAndGasAreaPage = createServiceAreaPage({
  servicePath: 'heating-and-gas',
  baseUrl: 'https://www.qeeper.co.uk',
});

export const getStaticPaths = createServiceAreaStaticPaths;
export const getStaticProps = createServiceAreaStaticProps('heating-and-gas');

export default HeatingAndGasAreaPage;
